import { render } from "./PreviewHeaderScrollNavi.vue?vue&type=template&id=ae005748&scoped=true"
import script from "./PreviewHeaderScrollNavi.vue?vue&type=script&lang=js"
export * from "./PreviewHeaderScrollNavi.vue?vue&type=script&lang=js"

import "./PreviewHeaderScrollNavi.vue?vue&type=style&index=0&id=ae005748&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae005748"]])

export default __exports__